import { useCallback, useEffect, useRef, useState } from "react";
import "../../../node_modules/tabulator-tables/dist/css/tabulator_bootstrap4.css";
import "../../../node_modules/semantic-ui-css/components/icon.min.css";
import { TabulatorFull as Tabulator } from "tabulator-tables";
import React from "react";
import { getDataSetNamePBI, useHttpClient } from "../modules/services/Bundle";
import { IGatewaysModel } from "../modules/services/core/_models";
import { RequestMethod } from "../modules/services/core/_enums";
import ReactApexChart from 'react-apexcharts';
import { useLocation } from "react-router-dom";
import moment from "moment";




const MenuGatewayDetail: React.FC = () => {
  const location = useLocation();
  const httpClient = useHttpClient();
  const [detalhesGateway, setDetalhesGateway] = useState<IGatewaysModel[]>([]);
  const [filteredGateways, setFilteredGateways] = useState<IGatewaysModel[]>([]);
  const [selectedOrganization, setSelectedOrganization] = useState<string>("");
  const [gatewayFilter, setGatewayFilter] = useState<string>("");
  const gatewayTableRef = useRef<HTMLDivElement>(null);
  const chamadosTableRef = useRef<HTMLDivElement>(null);
  const [selectedGateway, setSelectedGateway] = useState<string | null>(null);
  const chamadosTable = useRef<Tabulator | null>(null);
  const [chamadosGateway, setChamadosGateway] = useState<any[]>([]);
  const dataSetNamePBI = getDataSetNamePBI();
  const backendUrl = process.env.REACT_APP_BACKEND_URL;


  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const gatewayParam = searchParams.get("gateway");

    if (gatewayParam) {
      setSelectedGateway(gatewayParam);
      handleGatewaySelection(gatewayParam);
    }
  }, [location]);


  const obterDetalhesGateway = async () => {
    const response = await httpClient.request({
      method: RequestMethod.GET,
      endpoint: '/Gerenciamento/PowerBI/ObterGateways',
      queryObject: {
        datasetName: dataSetNamePBI,
      },
    });
    if (response.success && response.payload) {
      console.log(response.payload);
      setDetalhesGateway(response.payload);
      setFilteredGateways(response.payload);
    }
  };
  const obterChamadosGateway = async (gateway: string) => {
    try {
      const response = await fetch(`${backendUrl}/api/PlaceWorkFlow/ByGatewayName/${gateway}`, {
        method: 'GET',
        headers: {
          'Accept': '*/*',
        },
      });

      if (response.ok) {
        const data = await response.json();
        console.log(data);
        // Filtra os dados com base no selectedGateway
        const filteredData = data.filter((item: any) => {
          try {
            const parsedData = JSON.parse(item.Dados);
            return parsedData.Gateway === gateway;
          } catch (e) {
            console.error('Erro ao parsear JSON:', e);
            return false;
          }
        });
        setChamadosGateway(filteredData);
      } else {
        console.error('Erro ao buscar dados:', response.statusText);
      }
    } catch (error) {
      console.error('Erro ao buscar dados:', error);
    }
  };

  const handleGatewaySelection = useCallback((gateway: string) => {
    setSelectedGateway(gateway);
    if (gateway) {
      obterChamadosGateway(gateway);
    }
  }, []);

  const handleOrganizationFilter = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const organization = event.target.value;
    setSelectedOrganization(organization);
    filterGateways(organization, gatewayFilter);
  };

  const handleGatewayFilter = (event: React.ChangeEvent<HTMLInputElement>) => {
    const gateway = event.target.value;
    setGatewayFilter(gateway);
    filterGateways(selectedOrganization, gateway);
  };
  const chartOptions: ApexCharts.ApexOptions = {
    chart: {
      type: 'radialBar' as const,
      background: 'var(--bs-body-bg)', // Fundo baseado no tema
      foreColor: 'var(--bs-body-color)', // Cor do texto baseada no tema
    },
    series: [
      selectedGateway
        ? parseFloat(
          detalhesGateway.find((gateway) => gateway.Gateway === selectedGateway)
            ?.Temperature as unknown as string || "0"
        )
        : 0,
    ],
    labels: ['Temperatura'],
    plotOptions: {
      radialBar: {
        startAngle: -135,
        endAngle: 135,
        hollow: {
          margin: 5,
          size: '60%',
          background: 'transparent',
        },
        dataLabels: {
          name: {
            fontSize: '22px',
            color: 'var(--bs-body-color)', // Cor do texto baseada no tema
          },
          value: {
            fontSize: '22px',
            color: 'var(--bs-body-color)', // Cor do texto baseada no tema
            formatter: function (val) {
              return parseFloat(val.toString()).toFixed(1);
            },
          },
          total: {
            show: true,
            label: 'Temperatura',
            color: 'var(--bs-body-color)', // Cor do texto baseada no tema
            formatter: function (w) {
              return (
                w.globals.seriesTotals.reduce((a: any, b: any) => a + b, 0).toFixed(1) + "°C");
            },
          },
        },
      },
    },
    colors: [
      function ({ value }: { value: number }) {
        if (value >= 80) {
          return '#FF0000'; // Vermelho
        } else {
          return '#00FF00'; // Verde
        }
      },
    ],
    annotations: {
      points: [
        {
          x: 80,
          y: 0,
          marker: {
            size: 6,
            fillColor: '#FF0000',
            strokeColor: '#FF0000',
            radius: 2,
          },
          label: {
            borderColor: '#FF0000',
            offsetY: -10,
            style: {
              color: '#FF0000',
              background: 'var(--bs-body-bg)', // Fundo baseado no tema
            },
            text: '80°C',
          },
        },
      ],
      yaxis: [
        {
          y: 80,
          borderColor: '#FF0000',
          label: {
            borderColor: '#FF0000',
            style: {
              color: 'var(--bs-body-color)', // Cor do texto baseada no tema
              background: '#FF0000',
            },
            text: 'Limite de 80°C',
          },
        },
      ],
    },
  };

  const filterGateways = (organization: string, gateway: string) => {
    let filtered = detalhesGateway;
    if (organization) {
      filtered = filtered.filter(g => g['Organizacao'] === organization);
    }
    if (gateway) {
      filtered = filtered.filter(g => g['Gateway'].includes(gateway));
    }
    setFilteredGateways(filtered);
  };

  useEffect(() => {
    obterDetalhesGateway();
  }, []);

  useEffect(() => {
    if (gatewayTableRef.current) {
      const table = new Tabulator(gatewayTableRef.current, {
        layout: "fitColumns",
        columns: [
          { title: "Campo", field: "field", width: 150 },
          { title: "Valor", field: "value", widthGrow: 1 },
        ],
      });
      if (selectedGateway) {
        const selectedData = detalhesGateway.find((detalhes) => detalhes.Gateway === selectedGateway);
        if (selectedData) {
          const tableData = Object.entries(selectedData).map(([key, value]) => ({
            field: key,
            value: value,
          }));
          table.setData(tableData);
          obterChamadosGateway(selectedGateway);
        } else {
          table.clearData();
        }
      } else {
        table.clearData();
      }
    }
  }, [selectedGateway]);
  const atualizarChamados = () => {
    if (chamadosTableRef.current && selectedGateway) {
      const filteredChamados = chamadosGateway.filter((chamado) => JSON.parse(chamado.Dados).Gateway === selectedGateway);

      if (filteredChamados.length > 0) {
        if (chamadosTable.current) {
          chamadosTable.current.clearData();
          console.log(filteredChamados);
          chamadosTable.current.setData(filteredChamados);
        }
      } else {
        chamadosTableRef.current.innerHTML = `<div style="color: gray; text-align: center; padding: 20px;">Não há alertas cadastrados para o gateway ${selectedGateway}</div>`;
      }
    }
  };

  useEffect(() => {
    if (chamadosTableRef.current) {
      if (selectedGateway) {
        const filteredChamados = chamadosGateway.filter((chamado) => JSON.parse(chamado.Dados).Gateway === selectedGateway);

        if (filteredChamados.length > 0) {
          chamadosTable.current = new Tabulator(chamadosTableRef.current, {
            height: "400px",
            layout: "fitColumns",
            data: filteredChamados,
            initialSort: [
              { column: "DataCriacao", dir: "asc" }
            ],
            columns: [
              {
                title: "", field: "Status", formatter: function (cell, f) {
                  var data = cell.getData();
                  var icon = data.Status ? '<i class="ui small green check icon"></i>' : '<i class="ui small clock icon"></i>';
                  return `<div style="display: flex; align-items: center; justify-content: center;">${icon}</div>`;
                },
                hozAlign: "center", resizable: false, headerSort: false, width: 50,
              },
              {
                title: "", field: "IdAlertLevel", formatter: function (cell, f) {
                  var data = cell.getData();
                  var icon;
                  switch (parseInt(data.IdAlertLevel)) {
                    case 1:
                    case 2:
                      icon = '<i class="ui small yellow exclamation triangle icon"></i>';
                      break;
                    case 3:
                      icon = '<i class="ui small orange exclamation triangle icon"></i>';
                      break;
                    case 4:
                    case 5:
                      icon = '<i class="ui small red exclamation triangle icon"></i>';
                      break;
                    default:
                      icon = '<i class="ui small gray exclamation triangle icon"></i>';
                  }
                  return `<div style="display: flex; align-items: center; justify-content: center;">${icon}</div>`;
                },
                hozAlign: "center", resizable: false, headerSort: false, width: 50,
              },
              {
                title: "Número do Chamado", field: "Chamado", sorter: "string",
                formatter: function (cell, f) {
                  var data = cell.getData();
                  var numeroChamado = data.Chamado;
                  var icon = numeroChamado ? '' : `<i class="ui small red icon plus circle" style="padding: 2px; cursor: pointer;" onclick="window.location.href='/novo-chamado-gateway?var-IdWorkFlow=${data.IdWorkFlow}'">  Incluir</i>`;
                  return `<div style="display: flex; align-items: center;"><span style="margin-right: 5px;">${icon}</span><span>${numeroChamado || ''}</span></div>`;
                },
                hozAlign: "center", resizable: false, headerSort: false, tooltip: 'Número do Chamado', width: 150,
              },
              {
                title: "Interações",
                field: "IdWorkFlow",
                formatter: function (cell, f) {
                  var data = cell.getData();
                  var redirectIcon = `<i class="ui small blue icon external alternate" style="padding: 1px; cursor: pointer; color: blue;" onclick="window.location.href='/chamado-gateway?IdWorkFlow=${data.IdWorkFlow}'"></i>`;
                  var balloonIcon = '<i class="ui small icon comment alternate" style="padding: 1px; cursor: pointer;"></i>';
                  return `<div style="display: flex; align-items: center;"><span style="margin-right: 5px;">${redirectIcon}</span><span style="margin-right: 5px;">${balloonIcon}</span><span></span></div>`;
                },
                hozAlign: "center",
                resizable: false,
                headerSort: false,
                tooltip: 'Interações',
                width: 150,
              },
              {
                title: "PDF",
                field: "IdWorkFlow",
                formatter: function (cell) {
                  const idworkflow = cell.getValue();
                  return `<button 
                            class="ui small icon button red"
                            onclick="window.open('${backendUrl}/Report/PlaceAlertDownloadPDF?IdWorkFlow=${idworkflow}', '_blank')"
                          >
                            <i class="ui file pdf outline icon"></i>
                          </button>`;
                },
                hozAlign: "center",
                headerSort: false,
                width: 100
              },
              { title: "Assunto", field: "Assunto", sorter: "string" },
              { title: "Requisitante", field: "UsuarioOwner", sorter: "string" },
              { title: "Responsável", field: "UsuarioResponsible", sorter: "string" },
              {
                title: "Inclusão",
                field: "DataCriacao",
                sorter: (a, b) => {
                  const dateA = moment(a, "DD/MM/YYYY HH:mm:ss", true);
                  const dateB = moment(b, "DD/MM/YYYY HH:mm:ss", true);

                  if (!dateA.isValid() && !dateB.isValid()) return 0;
                  if (!dateA.isValid()) return 1;
                  if (!dateB.isValid()) return -1;

                  return dateB.diff(dateA); // Ordena em ordem decrescente
                },
                formatter: (cell: any) => {
                  const value = cell.getValue();
                  if (!value) return " - ";

                  if (typeof value === 'string' && value.match(/^\d{2}\/\d{2}\/\d{4} \d{2}:\d{2}:\d{2}$/)) {
                    return value;
                  }

                  const date = moment(value);
                  return date.isValid() ? date.format("DD/MM/YYYY HH:mm:ss") : "N/A";
                },
              },
            ],
          });
        } else {
          chamadosTableRef.current.innerHTML = `<div style="color: gray; text-align: center; padding: 20px;">Não há alertas cadastrados para o gateway ${selectedGateway}</div>`;
        }
      } else {
        chamadosTableRef.current.innerHTML = '';
      }
    }
  }, [selectedGateway, chamadosGateway]);



  return (
    <>
      <style>
        {`
          @media (max-width: 1024px) {
            .gateway-detail-container {
              flex-direction: column !important;
            }
            .gateway-sidebar {
              width: 100% !important;
              display: ${selectedGateway ? 'none' : 'flex'} !important;
            }
            .gateway-details, .gateway-alertas {
              width: 100% !important;
              display: ${selectedGateway ? 'block' : 'none'} !important;
            }
            .gateway-back-button {
              display: ${selectedGateway ? 'block' : 'none'} !important;
              margin-bottom: 10px;
            }
          }
          @media (min-width: 1025px) {
            .gateway-back-button {
              display: none !important;
            }
          }
        `}
      </style>
      <div className="d-flex gateway-detail-container" style={{ height: "80vh" }}>
        <div className="gateway-sidebar" style={{ display: "flex", flexDirection: "column", width: "15%", padding: "10px" }}>
          {/* Filtro de Organização */}
          <div style={{ marginBottom: "10px" }}>
            <label htmlFor="organizationFilter" style={{ marginRight: "10px", fontWeight: "bold" }}>Organização:</label>
            <select
              id="organizationFilter"
              value={selectedOrganization}
              onChange={handleOrganizationFilter}
              style={{
                width: "100%",
                padding: "5px",
                borderRadius: "5px",
                border: "1px solid var(--bs-border-color)",
                boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                backgroundColor: "var(--bs-body-bg)",
                color: "var(--bs-body-color)",
              }}
            >
              <option value="">Todas</option>
              {Array.from(new Set(detalhesGateway.map(gateway => gateway['Organizacao']))).map((organization, index) => (
                <option key={index} value={organization}>{organization}</option>
              ))}
            </select>
          </div>

          {/* Título e Filtro de Gateway */}
          <div style={{ marginBottom: "10px", textAlign: "center" }}>
            <h4 style={{ marginBottom: "10px" }}>Lista de Gateways</h4>
            <input
              type="text"
              placeholder="Digite o codigo do gateway"
              value={gatewayFilter}
              onChange={handleGatewayFilter}
              style={{
                width: "100%",
                padding: "5px",
                borderRadius: "5px",
                border: "1px solid var(--bs-border-color)",
                boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                backgroundColor: "var(--bs-body-bg)",
                color: "var(--bs-body-color)",
              }}
            />
          </div>
          {/* Lista de Gateways */}
          <div
            className="sidebar"
            style={{
              borderRight: "1px solid var(--bs-border-color)",
              borderBottom: "1px solid var(--bs-border-color)",
              padding: "10px",
              overflowY: "auto",
              maxHeight: "100%",
              borderRadius: "5px",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
            }}
          >
            <ul style={{ listStyleType: "none", padding: 0 }}>
              {filteredGateways && filteredGateways.length > 0 && filteredGateways.map((gateway: IGatewaysModel) => (
                <li
                  key={gateway.Gateway}
                  className={selectedGateway?.trim() === gateway.Gateway.trim() ? 'selected' : ''}
                  style={{
                    padding: "10px",
                    marginBottom: "8px",
                    border: "1px solid var(--bs-border-color)",
                    borderRadius: "5px",
                    backgroundColor: selectedGateway?.trim() === gateway.Gateway.trim() ? "var(--bs-secondary-bg)" : "var(--bs-body-bg)",
                    color: "var(--bs-body-color)",
                    fontWeight: selectedGateway?.trim() === gateway.Gateway.trim() ? "bold" : "normal",
                    cursor: "pointer",
                    transition: "background-color 0.3s ease, color 0.3s ease",
                    textAlign: "center",
                  }}
                  onClick={() => handleGatewaySelection(gateway.Gateway)}
                >
                  {gateway.Gateway}
                </li>
              ))}
            </ul>
          </div>
        </div>



        <div className="gateway-details" style={{ width: "35%", padding: "10px" }}>
          <button 
            className="gateway-back-button btn btn-secondary btn-sm"
            onClick={() => setSelectedGateway(null)}
          >
            <i className="fas fa-arrow-left"></i> Voltar
          </button>
          <h1 style={{ textAlign: "center", marginBottom: "0px", borderBottom: "0px solid var(--bs-border-color)" }}>Detalhamento do Gateway</h1>
        {selectedGateway ? (
          <div
            className="detalhamento-gateway"
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: "5px",
              padding: "20px",
              border: "2px solid var(--bs-border-color)",
              borderRadius: "10px",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)"
            }}
          >
            {detalhesGateway
              .filter((gateway) => gateway.Gateway === selectedGateway).map((gateway, index) => (
                <React.Fragment key={index}>
                  <div style={{ fontWeight: "bold", border: "1px solid var(--bs-border-color)", padding: "10px", backgroundColor: "var(--bs-secondary-bg)" }}>Última Atualização:</div>
                  <div style={{ border: "1px solid var(--bs-border-color)", padding: "10px", backgroundColor: "var(--bs-body-bg)" }}>{gateway.UltimaAtualizacao}</div>
                  <div style={{ fontWeight: "bold", border: "1px solid var(--bs-border-color)", padding: "10px", backgroundColor: "var(--bs-secondary-bg)" }}>Local:</div>
                  <div style={{ border: "1px solid var(--bs-border-color)", padding: "10px", backgroundColor: "var(--bs-body-bg)" }}>{gateway.Local}</div>
                  <div style={{ fontWeight: "bold", border: "1px solid var(--bs-border-color)", padding: "10px", backgroundColor: "var(--bs-secondary-bg)" }}>Tipo do local:</div>
                  <div style={{ border: "1px solid var(--bs-border-color)", padding: "10px", backgroundColor: "var(--bs-body-bg)" }}>{gateway.PlaceType}</div>
                  <div style={{ fontWeight: "bold", border: "1px solid var(--bs-border-color)", padding: "10px", backgroundColor: "var(--bs-secondary-bg)" }}>Organização:</div>
                  <div style={{ border: "1px solid var(--bs-border-color)", padding: "10px", backgroundColor: "var(--bs-body-bg)" }}>{gateway.Corporation}</div>
                  <div style={{ fontWeight: "bold", border: "1px solid var(--bs-border-color)", padding: "10px", backgroundColor: "var(--bs-secondary-bg)" }}>Nro de serie:</div>
                  <div style={{ border: "1px solid var(--bs-border-color)", padding: "10px", backgroundColor: "var(--bs-body-bg)" }}>{gateway.Gateway}</div>
                  <div style={{ fontWeight: "bold", border: "1px solid var(--bs-border-color)", padding: "10px", backgroundColor: "var(--bs-secondary-bg)" }}>Local desabilitado:</div>
                  <div style={{ border: "1px solid var(--bs-border-color)", padding: "10px", backgroundColor: "var(--bs-body-bg)" }}>{gateway.LocalSituacao}</div>
                  <div style={{ fontWeight: "bold", border: "1px solid var(--bs-border-color)", padding: "10px", backgroundColor: "var(--bs-secondary-bg)" }}>Middleware:</div>
                  <div style={{ border: "1px solid var(--bs-border-color)", padding: "10px", backgroundColor: "var(--bs-body-bg)" }}>{".NET"}</div>
                </React.Fragment>
              ))}
            <div style={{ gridColumn: "span 2", display: "flex", justifyContent: "space-between", marginTop: "20px" }}>
              {/* Status Online/Offline */}
              <div className="status-container" style={{
                width: "50%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                border: "2px solid var(--bs-border-color)",
                borderRadius: "10px",
                padding: "10px",
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)"
              }}>
                <div style={{
                  width: "100%",
                  height: "100%",
                  borderRadius: "5px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontWeight: "bold",
                  fontSize: "36px",
                  color: detalhesGateway.find(gateway => gateway.Gateway === selectedGateway)?.Status === "online" ? "var(--bs-success)" : "var(--bs-danger)"
                }}>
                  {detalhesGateway.find(gateway => gateway.Gateway === selectedGateway)?.Status === "online" ? "Online" : "Offline"}
                </div>
              </div>
              {/* Gráfico */}
              <div className="chart-container" style={{
                width: "50%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                border: "2px solid var(--bs-border-color)",
                borderRadius: "10px",
                padding: "10px",
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)"
              }}>
                <ReactApexChart options={chartOptions} series={chartOptions.series} type="radialBar" height={225} />
              </div>
            </div>
          </div>
        ) : (
          <p style={{ textAlign: "center" }}>Selecione um Gateway para ver os detalhes</p>
        )}
      </div>
      {/* Menu lateral de Chamados */}
      <div className="gateway-alertas" style={{ width: "56%", borderLeft: "1px solid var(--bs-border-color)", padding: "5px" }}>
        <h4>Alertas</h4>
        <div style={{ marginBottom: '10px', display: 'flex', justifyContent: 'flex-start', gap: '10px' }}>
          <button onClick={() => window.location.href = `/Criar-alerta-gateway?gateway=${selectedGateway}`} style={{ display: 'flex', alignItems: 'center', padding: '5px 10px', borderRadius: '5px', border: "1px solid var(--bs-border-color)", backgroundColor: "var(--bs-body-bg)", color: "var(--bs-body-color)", cursor: 'pointer' }}>
            <i className="fas fa-plus" style={{ marginRight: '5px' }}></i> Novo
          </button>
          <button onClick={atualizarChamados} style={{ display: 'flex', alignItems: 'center', padding: '5px 10px', borderRadius: '5px', border: "1px solid var(--bs-border-color)", backgroundColor: "var(--bs-body-bg)", color: "var(--bs-body-color)", cursor: 'pointer' }}>
            <i className="fas fa-sync-alt" style={{ marginRight: '5px' }}></i> Atualizar
          </button>
        </div>
        <div ref={chamadosTableRef}></div>
      </div>
    </div>
    </>
  );
};

export default MenuGatewayDetail;